/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhatsNewRouteImport } from './routes/whats-new'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as QualityRouteImport } from './routes/quality'
import { Route as MemoryRouteImport } from './routes/memory'
import { Route as HomeRouteImport } from './routes/home'
import { Route as GameRouteImport } from './routes/game'
import { Route as DeveloperRouteImport } from './routes/developer'
import { Route as ContributorsRouteImport } from './routes/contributors'
import { Route as CodeQualityRouteImport } from './routes/code-quality'
import { Route as ChatsRouteImport } from './routes/chats'
import { Route as BlockedRouteImport } from './routes/blocked'
import { Route as ArtifactsRouteImport } from './routes/artifacts'
import { Route as AdminPanelRouteImport } from './routes/admin-panel'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ScheduledIndexRouteImport } from './routes/scheduled.index'
import { Route as DiagramsIndexRouteImport } from './routes/diagrams.index'
import { Route as DevelopersIndexRouteImport } from './routes/developers.index'
import { Route as DecksIndexRouteImport } from './routes/decks.index'
import { Route as DashboardsIndexRouteImport } from './routes/dashboards.index'
import { Route as SharedShareIdRouteImport } from './routes/shared.$shareId'
import { Route as ShareShareIdRouteImport } from './routes/share.$shareId'
import { Route as SecretaryAccessRouteImport } from './routes/secretary.access'
import { Route as ScheduledIdRouteImport } from './routes/scheduled.$id'
import { Route as ReportsRunIdRouteImport } from './routes/reports_.$runId'
import { Route as QualityIdRouteImport } from './routes/quality_.$id'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'
import { Route as DiagramsIdRouteImport } from './routes/diagrams.$id'
import { Route as DevelopersSpendingRouteImport } from './routes/developers.spending'
import { Route as DevelopersIdRouteImport } from './routes/developers.$id'
import { Route as DeveloperSpendingRouteImport } from './routes/developer_.spending'
import { Route as DeveloperActivityRouteImport } from './routes/developer_.activity'
import { Route as DevMailingRouteImport } from './routes/dev.mailing'
import { Route as DecksIdRouteImport } from './routes/decks.$id'
import { Route as DashboardsCodeQualityRouteImport } from './routes/dashboards.code-quality'
import { Route as DashboardsIdRouteImport } from './routes/dashboards.$id'
import { Route as ArtifactsTransferRouteImport } from './routes/artifacts_.transfer'
import { Route as WorkspacesIdManageRouteImport } from './routes/workspaces.$id.manage'
import { Route as SecretaryConnectRequestIdRouteImport } from './routes/secretary.connect.$requestId'
import { Route as SecretaryApprovalsApprovalIdRouteImport } from './routes/secretary.approvals.$approvalId'
import { Route as ScheduledSharedShareIdRouteImport } from './routes/scheduled_.shared.$shareId'
import { Route as QualitySuitesIdRouteImport } from './routes/quality_.suites.$id'
import { Route as DiagramsSharedShareIdRouteImport } from './routes/diagrams_.shared.$shareId'
import { Route as DashboardsSharedShareIdRouteImport } from './routes/dashboards_.shared.$shareId'
import { Route as WorkspacesIdCodeQualityProjectIdRouteImport } from './routes/workspaces.$id.code-quality.$projectId'
import { Route as QualityFindingsIdChatRouteImport } from './routes/quality_.findings.$id.chat'
import { Route as ScheduledSharedShareIdReportsRunIdRouteImport } from './routes/scheduled_.shared.$shareId_.reports.$runId'

const WhatsNewRoute = WhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityRoute = QualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryRoute = MemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const GameRoute = GameRouteImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRouteImport,
} as any)
const DeveloperRoute = DeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => rootRouteImport,
} as any)
const ContributorsRoute = ContributorsRouteImport.update({
  id: '/contributors',
  path: '/contributors',
  getParentRoute: () => rootRouteImport,
} as any)
const CodeQualityRoute = CodeQualityRouteImport.update({
  id: '/code-quality',
  path: '/code-quality',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatsRoute = ChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockedRoute = BlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtifactsRoute = ArtifactsRouteImport.update({
  id: '/artifacts',
  path: '/artifacts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPanelRoute = AdminPanelRouteImport.update({
  id: '/admin-panel',
  path: '/admin-panel',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledIndexRoute = ScheduledIndexRouteImport.update({
  id: '/scheduled/',
  path: '/scheduled/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagramsIndexRoute = DiagramsIndexRouteImport.update({
  id: '/diagrams/',
  path: '/diagrams/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersIndexRoute = DevelopersIndexRouteImport.update({
  id: '/developers/',
  path: '/developers/',
  getParentRoute: () => rootRouteImport,
} as any)
const DecksIndexRoute = DecksIndexRouteImport.update({
  id: '/decks/',
  path: '/decks/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsIndexRoute = DashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedShareIdRoute = SharedShareIdRouteImport.update({
  id: '/shared/$shareId',
  path: '/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareShareIdRoute = ShareShareIdRouteImport.update({
  id: '/share/$shareId',
  path: '/share/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretaryAccessRoute = SecretaryAccessRouteImport.update({
  id: '/secretary/access',
  path: '/secretary/access',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledIdRoute = ScheduledIdRouteImport.update({
  id: '/scheduled/$id',
  path: '/scheduled/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRunIdRoute = ReportsRunIdRouteImport.update({
  id: '/reports_/$runId',
  path: '/reports/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityIdRoute = QualityIdRouteImport.update({
  id: '/quality_/$id',
  path: '/quality/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagramsIdRoute = DiagramsIdRouteImport.update({
  id: '/diagrams/$id',
  path: '/diagrams/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersSpendingRoute = DevelopersSpendingRouteImport.update({
  id: '/developers/spending',
  path: '/developers/spending',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersIdRoute = DevelopersIdRouteImport.update({
  id: '/developers/$id',
  path: '/developers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DeveloperSpendingRoute = DeveloperSpendingRouteImport.update({
  id: '/developer_/spending',
  path: '/developer/spending',
  getParentRoute: () => rootRouteImport,
} as any)
const DeveloperActivityRoute = DeveloperActivityRouteImport.update({
  id: '/developer_/activity',
  path: '/developer/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const DevMailingRoute = DevMailingRouteImport.update({
  id: '/dev/mailing',
  path: '/dev/mailing',
  getParentRoute: () => rootRouteImport,
} as any)
const DecksIdRoute = DecksIdRouteImport.update({
  id: '/decks/$id',
  path: '/decks/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsCodeQualityRoute = DashboardsCodeQualityRouteImport.update({
  id: '/dashboards/code-quality',
  path: '/dashboards/code-quality',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsIdRoute = DashboardsIdRouteImport.update({
  id: '/dashboards/$id',
  path: '/dashboards/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtifactsTransferRoute = ArtifactsTransferRouteImport.update({
  id: '/artifacts_/transfer',
  path: '/artifacts/transfer',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIdManageRoute = WorkspacesIdManageRouteImport.update({
  id: '/workspaces/$id/manage',
  path: '/workspaces/$id/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretaryConnectRequestIdRoute =
  SecretaryConnectRequestIdRouteImport.update({
    id: '/secretary/connect/$requestId',
    path: '/secretary/connect/$requestId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SecretaryApprovalsApprovalIdRoute =
  SecretaryApprovalsApprovalIdRouteImport.update({
    id: '/secretary/approvals/$approvalId',
    path: '/secretary/approvals/$approvalId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScheduledSharedShareIdRoute = ScheduledSharedShareIdRouteImport.update({
  id: '/scheduled_/shared/$shareId',
  path: '/scheduled/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const QualitySuitesIdRoute = QualitySuitesIdRouteImport.update({
  id: '/quality_/suites/$id',
  path: '/quality/suites/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagramsSharedShareIdRoute = DiagramsSharedShareIdRouteImport.update({
  id: '/diagrams_/shared/$shareId',
  path: '/diagrams/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsSharedShareIdRoute = DashboardsSharedShareIdRouteImport.update({
  id: '/dashboards_/shared/$shareId',
  path: '/dashboards/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIdCodeQualityProjectIdRoute =
  WorkspacesIdCodeQualityProjectIdRouteImport.update({
    id: '/workspaces/$id/code-quality/$projectId',
    path: '/workspaces/$id/code-quality/$projectId',
    getParentRoute: () => rootRouteImport,
  } as any)
const QualityFindingsIdChatRoute = QualityFindingsIdChatRouteImport.update({
  id: '/quality_/findings/$id/chat',
  path: '/quality/findings/$id/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledSharedShareIdReportsRunIdRoute =
  ScheduledSharedShareIdReportsRunIdRouteImport.update({
    id: '/scheduled_/shared/$shareId_/reports/$runId',
    path: '/scheduled/shared/$shareId/reports/$runId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-panel': typeof AdminPanelRoute
  '/artifacts': typeof ArtifactsRoute
  '/blocked': typeof BlockedRoute
  '/chats': typeof ChatsRoute
  '/code-quality': typeof CodeQualityRoute
  '/contributors': typeof ContributorsRoute
  '/developer': typeof DeveloperRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/memory': typeof MemoryRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/tasks': typeof TasksRoute
  '/whats-new': typeof WhatsNewRoute
  '/artifacts/transfer': typeof ArtifactsTransferRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/dashboards/code-quality': typeof DashboardsCodeQualityRoute
  '/decks/$id': typeof DecksIdRoute
  '/dev/mailing': typeof DevMailingRoute
  '/developer/activity': typeof DeveloperActivityRoute
  '/developer/spending': typeof DeveloperSpendingRoute
  '/developers/$id': typeof DevelopersIdRoute
  '/developers/spending': typeof DevelopersSpendingRoute
  '/diagrams/$id': typeof DiagramsIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/quality/$id': typeof QualityIdRoute
  '/reports/$runId': typeof ReportsRunIdRoute
  '/scheduled/$id': typeof ScheduledIdRoute
  '/secretary/access': typeof SecretaryAccessRoute
  '/share/$shareId': typeof ShareShareIdRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/decks/': typeof DecksIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/diagrams/': typeof DiagramsIndexRoute
  '/scheduled/': typeof ScheduledIndexRoute
  '/dashboards/shared/$shareId': typeof DashboardsSharedShareIdRoute
  '/diagrams/shared/$shareId': typeof DiagramsSharedShareIdRoute
  '/quality/suites/$id': typeof QualitySuitesIdRoute
  '/scheduled/shared/$shareId': typeof ScheduledSharedShareIdRoute
  '/secretary/approvals/$approvalId': typeof SecretaryApprovalsApprovalIdRoute
  '/secretary/connect/$requestId': typeof SecretaryConnectRequestIdRoute
  '/workspaces/$id/manage': typeof WorkspacesIdManageRoute
  '/quality/findings/$id/chat': typeof QualityFindingsIdChatRoute
  '/workspaces/$id/code-quality/$projectId': typeof WorkspacesIdCodeQualityProjectIdRoute
  '/scheduled/shared/$shareId/reports/$runId': typeof ScheduledSharedShareIdReportsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-panel': typeof AdminPanelRoute
  '/artifacts': typeof ArtifactsRoute
  '/blocked': typeof BlockedRoute
  '/chats': typeof ChatsRoute
  '/code-quality': typeof CodeQualityRoute
  '/contributors': typeof ContributorsRoute
  '/developer': typeof DeveloperRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/memory': typeof MemoryRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/tasks': typeof TasksRoute
  '/whats-new': typeof WhatsNewRoute
  '/artifacts/transfer': typeof ArtifactsTransferRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/dashboards/code-quality': typeof DashboardsCodeQualityRoute
  '/decks/$id': typeof DecksIdRoute
  '/dev/mailing': typeof DevMailingRoute
  '/developer/activity': typeof DeveloperActivityRoute
  '/developer/spending': typeof DeveloperSpendingRoute
  '/developers/$id': typeof DevelopersIdRoute
  '/developers/spending': typeof DevelopersSpendingRoute
  '/diagrams/$id': typeof DiagramsIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/quality/$id': typeof QualityIdRoute
  '/reports/$runId': typeof ReportsRunIdRoute
  '/scheduled/$id': typeof ScheduledIdRoute
  '/secretary/access': typeof SecretaryAccessRoute
  '/share/$shareId': typeof ShareShareIdRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/dashboards': typeof DashboardsIndexRoute
  '/decks': typeof DecksIndexRoute
  '/developers': typeof DevelopersIndexRoute
  '/diagrams': typeof DiagramsIndexRoute
  '/scheduled': typeof ScheduledIndexRoute
  '/dashboards/shared/$shareId': typeof DashboardsSharedShareIdRoute
  '/diagrams/shared/$shareId': typeof DiagramsSharedShareIdRoute
  '/quality/suites/$id': typeof QualitySuitesIdRoute
  '/scheduled/shared/$shareId': typeof ScheduledSharedShareIdRoute
  '/secretary/approvals/$approvalId': typeof SecretaryApprovalsApprovalIdRoute
  '/secretary/connect/$requestId': typeof SecretaryConnectRequestIdRoute
  '/workspaces/$id/manage': typeof WorkspacesIdManageRoute
  '/quality/findings/$id/chat': typeof QualityFindingsIdChatRoute
  '/workspaces/$id/code-quality/$projectId': typeof WorkspacesIdCodeQualityProjectIdRoute
  '/scheduled/shared/$shareId/reports/$runId': typeof ScheduledSharedShareIdReportsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access-denied': typeof AccessDeniedRoute
  '/admin-panel': typeof AdminPanelRoute
  '/artifacts': typeof ArtifactsRoute
  '/blocked': typeof BlockedRoute
  '/chats': typeof ChatsRoute
  '/code-quality': typeof CodeQualityRoute
  '/contributors': typeof ContributorsRoute
  '/developer': typeof DeveloperRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/memory': typeof MemoryRoute
  '/quality': typeof QualityRoute
  '/reports': typeof ReportsRoute
  '/tasks': typeof TasksRoute
  '/whats-new': typeof WhatsNewRoute
  '/artifacts_/transfer': typeof ArtifactsTransferRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/dashboards/code-quality': typeof DashboardsCodeQualityRoute
  '/decks/$id': typeof DecksIdRoute
  '/dev/mailing': typeof DevMailingRoute
  '/developer_/activity': typeof DeveloperActivityRoute
  '/developer_/spending': typeof DeveloperSpendingRoute
  '/developers/$id': typeof DevelopersIdRoute
  '/developers/spending': typeof DevelopersSpendingRoute
  '/diagrams/$id': typeof DiagramsIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/quality_/$id': typeof QualityIdRoute
  '/reports_/$runId': typeof ReportsRunIdRoute
  '/scheduled/$id': typeof ScheduledIdRoute
  '/secretary/access': typeof SecretaryAccessRoute
  '/share/$shareId': typeof ShareShareIdRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/decks/': typeof DecksIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/diagrams/': typeof DiagramsIndexRoute
  '/scheduled/': typeof ScheduledIndexRoute
  '/dashboards_/shared/$shareId': typeof DashboardsSharedShareIdRoute
  '/diagrams_/shared/$shareId': typeof DiagramsSharedShareIdRoute
  '/quality_/suites/$id': typeof QualitySuitesIdRoute
  '/scheduled_/shared/$shareId': typeof ScheduledSharedShareIdRoute
  '/secretary/approvals/$approvalId': typeof SecretaryApprovalsApprovalIdRoute
  '/secretary/connect/$requestId': typeof SecretaryConnectRequestIdRoute
  '/workspaces/$id/manage': typeof WorkspacesIdManageRoute
  '/quality_/findings/$id/chat': typeof QualityFindingsIdChatRoute
  '/workspaces/$id/code-quality/$projectId': typeof WorkspacesIdCodeQualityProjectIdRoute
  '/scheduled_/shared/$shareId_/reports/$runId': typeof ScheduledSharedShareIdReportsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/admin-panel'
    | '/artifacts'
    | '/blocked'
    | '/chats'
    | '/code-quality'
    | '/contributors'
    | '/developer'
    | '/game'
    | '/home'
    | '/memory'
    | '/quality'
    | '/reports'
    | '/tasks'
    | '/whats-new'
    | '/artifacts/transfer'
    | '/dashboards/$id'
    | '/dashboards/code-quality'
    | '/decks/$id'
    | '/dev/mailing'
    | '/developer/activity'
    | '/developer/spending'
    | '/developers/$id'
    | '/developers/spending'
    | '/diagrams/$id'
    | '/projects/$id'
    | '/quality/$id'
    | '/reports/$runId'
    | '/scheduled/$id'
    | '/secretary/access'
    | '/share/$shareId'
    | '/shared/$shareId'
    | '/dashboards/'
    | '/decks/'
    | '/developers/'
    | '/diagrams/'
    | '/scheduled/'
    | '/dashboards/shared/$shareId'
    | '/diagrams/shared/$shareId'
    | '/quality/suites/$id'
    | '/scheduled/shared/$shareId'
    | '/secretary/approvals/$approvalId'
    | '/secretary/connect/$requestId'
    | '/workspaces/$id/manage'
    | '/quality/findings/$id/chat'
    | '/workspaces/$id/code-quality/$projectId'
    | '/scheduled/shared/$shareId/reports/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-denied'
    | '/admin-panel'
    | '/artifacts'
    | '/blocked'
    | '/chats'
    | '/code-quality'
    | '/contributors'
    | '/developer'
    | '/game'
    | '/home'
    | '/memory'
    | '/quality'
    | '/reports'
    | '/tasks'
    | '/whats-new'
    | '/artifacts/transfer'
    | '/dashboards/$id'
    | '/dashboards/code-quality'
    | '/decks/$id'
    | '/dev/mailing'
    | '/developer/activity'
    | '/developer/spending'
    | '/developers/$id'
    | '/developers/spending'
    | '/diagrams/$id'
    | '/projects/$id'
    | '/quality/$id'
    | '/reports/$runId'
    | '/scheduled/$id'
    | '/secretary/access'
    | '/share/$shareId'
    | '/shared/$shareId'
    | '/dashboards'
    | '/decks'
    | '/developers'
    | '/diagrams'
    | '/scheduled'
    | '/dashboards/shared/$shareId'
    | '/diagrams/shared/$shareId'
    | '/quality/suites/$id'
    | '/scheduled/shared/$shareId'
    | '/secretary/approvals/$approvalId'
    | '/secretary/connect/$requestId'
    | '/workspaces/$id/manage'
    | '/quality/findings/$id/chat'
    | '/workspaces/$id/code-quality/$projectId'
    | '/scheduled/shared/$shareId/reports/$runId'
  id:
    | '__root__'
    | '/'
    | '/access-denied'
    | '/admin-panel'
    | '/artifacts'
    | '/blocked'
    | '/chats'
    | '/code-quality'
    | '/contributors'
    | '/developer'
    | '/game'
    | '/home'
    | '/memory'
    | '/quality'
    | '/reports'
    | '/tasks'
    | '/whats-new'
    | '/artifacts_/transfer'
    | '/dashboards/$id'
    | '/dashboards/code-quality'
    | '/decks/$id'
    | '/dev/mailing'
    | '/developer_/activity'
    | '/developer_/spending'
    | '/developers/$id'
    | '/developers/spending'
    | '/diagrams/$id'
    | '/projects/$id'
    | '/quality_/$id'
    | '/reports_/$runId'
    | '/scheduled/$id'
    | '/secretary/access'
    | '/share/$shareId'
    | '/shared/$shareId'
    | '/dashboards/'
    | '/decks/'
    | '/developers/'
    | '/diagrams/'
    | '/scheduled/'
    | '/dashboards_/shared/$shareId'
    | '/diagrams_/shared/$shareId'
    | '/quality_/suites/$id'
    | '/scheduled_/shared/$shareId'
    | '/secretary/approvals/$approvalId'
    | '/secretary/connect/$requestId'
    | '/workspaces/$id/manage'
    | '/quality_/findings/$id/chat'
    | '/workspaces/$id/code-quality/$projectId'
    | '/scheduled_/shared/$shareId_/reports/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  AdminPanelRoute: typeof AdminPanelRoute
  ArtifactsRoute: typeof ArtifactsRoute
  BlockedRoute: typeof BlockedRoute
  ChatsRoute: typeof ChatsRoute
  CodeQualityRoute: typeof CodeQualityRoute
  ContributorsRoute: typeof ContributorsRoute
  DeveloperRoute: typeof DeveloperRoute
  GameRoute: typeof GameRoute
  HomeRoute: typeof HomeRoute
  MemoryRoute: typeof MemoryRoute
  QualityRoute: typeof QualityRoute
  ReportsRoute: typeof ReportsRoute
  TasksRoute: typeof TasksRoute
  WhatsNewRoute: typeof WhatsNewRoute
  ArtifactsTransferRoute: typeof ArtifactsTransferRoute
  DashboardsIdRoute: typeof DashboardsIdRoute
  DashboardsCodeQualityRoute: typeof DashboardsCodeQualityRoute
  DecksIdRoute: typeof DecksIdRoute
  DevMailingRoute: typeof DevMailingRoute
  DeveloperActivityRoute: typeof DeveloperActivityRoute
  DeveloperSpendingRoute: typeof DeveloperSpendingRoute
  DevelopersIdRoute: typeof DevelopersIdRoute
  DevelopersSpendingRoute: typeof DevelopersSpendingRoute
  DiagramsIdRoute: typeof DiagramsIdRoute
  ProjectsIdRoute: typeof ProjectsIdRoute
  QualityIdRoute: typeof QualityIdRoute
  ReportsRunIdRoute: typeof ReportsRunIdRoute
  ScheduledIdRoute: typeof ScheduledIdRoute
  SecretaryAccessRoute: typeof SecretaryAccessRoute
  ShareShareIdRoute: typeof ShareShareIdRoute
  SharedShareIdRoute: typeof SharedShareIdRoute
  DashboardsIndexRoute: typeof DashboardsIndexRoute
  DecksIndexRoute: typeof DecksIndexRoute
  DevelopersIndexRoute: typeof DevelopersIndexRoute
  DiagramsIndexRoute: typeof DiagramsIndexRoute
  ScheduledIndexRoute: typeof ScheduledIndexRoute
  DashboardsSharedShareIdRoute: typeof DashboardsSharedShareIdRoute
  DiagramsSharedShareIdRoute: typeof DiagramsSharedShareIdRoute
  QualitySuitesIdRoute: typeof QualitySuitesIdRoute
  ScheduledSharedShareIdRoute: typeof ScheduledSharedShareIdRoute
  SecretaryApprovalsApprovalIdRoute: typeof SecretaryApprovalsApprovalIdRoute
  SecretaryConnectRequestIdRoute: typeof SecretaryConnectRequestIdRoute
  WorkspacesIdManageRoute: typeof WorkspacesIdManageRoute
  QualityFindingsIdChatRoute: typeof QualityFindingsIdChatRoute
  WorkspacesIdCodeQualityProjectIdRoute: typeof WorkspacesIdCodeQualityProjectIdRoute
  ScheduledSharedShareIdReportsRunIdRoute: typeof ScheduledSharedShareIdReportsRunIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/whats-new': {
      id: '/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof WhatsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality': {
      id: '/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof QualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory': {
      id: '/memory'
      path: '/memory'
      fullPath: '/memory'
      preLoaderRoute: typeof MemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game': {
      id: '/game'
      path: '/game'
      fullPath: '/game'
      preLoaderRoute: typeof GameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developer': {
      id: '/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof DeveloperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contributors': {
      id: '/contributors'
      path: '/contributors'
      fullPath: '/contributors'
      preLoaderRoute: typeof ContributorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/code-quality': {
      id: '/code-quality'
      path: '/code-quality'
      fullPath: '/code-quality'
      preLoaderRoute: typeof CodeQualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chats': {
      id: '/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof ChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocked': {
      id: '/blocked'
      path: '/blocked'
      fullPath: '/blocked'
      preLoaderRoute: typeof BlockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artifacts': {
      id: '/artifacts'
      path: '/artifacts'
      fullPath: '/artifacts'
      preLoaderRoute: typeof ArtifactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-panel': {
      id: '/admin-panel'
      path: '/admin-panel'
      fullPath: '/admin-panel'
      preLoaderRoute: typeof AdminPanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled/': {
      id: '/scheduled/'
      path: '/scheduled'
      fullPath: '/scheduled/'
      preLoaderRoute: typeof ScheduledIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagrams/': {
      id: '/diagrams/'
      path: '/diagrams'
      fullPath: '/diagrams/'
      preLoaderRoute: typeof DiagramsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers/': {
      id: '/developers/'
      path: '/developers'
      fullPath: '/developers/'
      preLoaderRoute: typeof DevelopersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decks/': {
      id: '/decks/'
      path: '/decks'
      fullPath: '/decks/'
      preLoaderRoute: typeof DecksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/': {
      id: '/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof DashboardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$shareId': {
      id: '/shared/$shareId'
      path: '/shared/$shareId'
      fullPath: '/shared/$shareId'
      preLoaderRoute: typeof SharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$shareId': {
      id: '/share/$shareId'
      path: '/share/$shareId'
      fullPath: '/share/$shareId'
      preLoaderRoute: typeof ShareShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secretary/access': {
      id: '/secretary/access'
      path: '/secretary/access'
      fullPath: '/secretary/access'
      preLoaderRoute: typeof SecretaryAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled/$id': {
      id: '/scheduled/$id'
      path: '/scheduled/$id'
      fullPath: '/scheduled/$id'
      preLoaderRoute: typeof ScheduledIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports_/$runId': {
      id: '/reports_/$runId'
      path: '/reports/$runId'
      fullPath: '/reports/$runId'
      preLoaderRoute: typeof ReportsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality_/$id': {
      id: '/quality_/$id'
      path: '/quality/$id'
      fullPath: '/quality/$id'
      preLoaderRoute: typeof QualityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagrams/$id': {
      id: '/diagrams/$id'
      path: '/diagrams/$id'
      fullPath: '/diagrams/$id'
      preLoaderRoute: typeof DiagramsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers/spending': {
      id: '/developers/spending'
      path: '/developers/spending'
      fullPath: '/developers/spending'
      preLoaderRoute: typeof DevelopersSpendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers/$id': {
      id: '/developers/$id'
      path: '/developers/$id'
      fullPath: '/developers/$id'
      preLoaderRoute: typeof DevelopersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developer_/spending': {
      id: '/developer_/spending'
      path: '/developer/spending'
      fullPath: '/developer/spending'
      preLoaderRoute: typeof DeveloperSpendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developer_/activity': {
      id: '/developer_/activity'
      path: '/developer/activity'
      fullPath: '/developer/activity'
      preLoaderRoute: typeof DeveloperActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/mailing': {
      id: '/dev/mailing'
      path: '/dev/mailing'
      fullPath: '/dev/mailing'
      preLoaderRoute: typeof DevMailingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decks/$id': {
      id: '/decks/$id'
      path: '/decks/$id'
      fullPath: '/decks/$id'
      preLoaderRoute: typeof DecksIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/code-quality': {
      id: '/dashboards/code-quality'
      path: '/dashboards/code-quality'
      fullPath: '/dashboards/code-quality'
      preLoaderRoute: typeof DashboardsCodeQualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/$id': {
      id: '/dashboards/$id'
      path: '/dashboards/$id'
      fullPath: '/dashboards/$id'
      preLoaderRoute: typeof DashboardsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artifacts_/transfer': {
      id: '/artifacts_/transfer'
      path: '/artifacts/transfer'
      fullPath: '/artifacts/transfer'
      preLoaderRoute: typeof ArtifactsTransferRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$id/manage': {
      id: '/workspaces/$id/manage'
      path: '/workspaces/$id/manage'
      fullPath: '/workspaces/$id/manage'
      preLoaderRoute: typeof WorkspacesIdManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secretary/connect/$requestId': {
      id: '/secretary/connect/$requestId'
      path: '/secretary/connect/$requestId'
      fullPath: '/secretary/connect/$requestId'
      preLoaderRoute: typeof SecretaryConnectRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secretary/approvals/$approvalId': {
      id: '/secretary/approvals/$approvalId'
      path: '/secretary/approvals/$approvalId'
      fullPath: '/secretary/approvals/$approvalId'
      preLoaderRoute: typeof SecretaryApprovalsApprovalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled_/shared/$shareId': {
      id: '/scheduled_/shared/$shareId'
      path: '/scheduled/shared/$shareId'
      fullPath: '/scheduled/shared/$shareId'
      preLoaderRoute: typeof ScheduledSharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality_/suites/$id': {
      id: '/quality_/suites/$id'
      path: '/quality/suites/$id'
      fullPath: '/quality/suites/$id'
      preLoaderRoute: typeof QualitySuitesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagrams_/shared/$shareId': {
      id: '/diagrams_/shared/$shareId'
      path: '/diagrams/shared/$shareId'
      fullPath: '/diagrams/shared/$shareId'
      preLoaderRoute: typeof DiagramsSharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards_/shared/$shareId': {
      id: '/dashboards_/shared/$shareId'
      path: '/dashboards/shared/$shareId'
      fullPath: '/dashboards/shared/$shareId'
      preLoaderRoute: typeof DashboardsSharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$id/code-quality/$projectId': {
      id: '/workspaces/$id/code-quality/$projectId'
      path: '/workspaces/$id/code-quality/$projectId'
      fullPath: '/workspaces/$id/code-quality/$projectId'
      preLoaderRoute: typeof WorkspacesIdCodeQualityProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality_/findings/$id/chat': {
      id: '/quality_/findings/$id/chat'
      path: '/quality/findings/$id/chat'
      fullPath: '/quality/findings/$id/chat'
      preLoaderRoute: typeof QualityFindingsIdChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled_/shared/$shareId_/reports/$runId': {
      id: '/scheduled_/shared/$shareId_/reports/$runId'
      path: '/scheduled/shared/$shareId/reports/$runId'
      fullPath: '/scheduled/shared/$shareId/reports/$runId'
      preLoaderRoute: typeof ScheduledSharedShareIdReportsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  AdminPanelRoute: AdminPanelRoute,
  ArtifactsRoute: ArtifactsRoute,
  BlockedRoute: BlockedRoute,
  ChatsRoute: ChatsRoute,
  CodeQualityRoute: CodeQualityRoute,
  ContributorsRoute: ContributorsRoute,
  DeveloperRoute: DeveloperRoute,
  GameRoute: GameRoute,
  HomeRoute: HomeRoute,
  MemoryRoute: MemoryRoute,
  QualityRoute: QualityRoute,
  ReportsRoute: ReportsRoute,
  TasksRoute: TasksRoute,
  WhatsNewRoute: WhatsNewRoute,
  ArtifactsTransferRoute: ArtifactsTransferRoute,
  DashboardsIdRoute: DashboardsIdRoute,
  DashboardsCodeQualityRoute: DashboardsCodeQualityRoute,
  DecksIdRoute: DecksIdRoute,
  DevMailingRoute: DevMailingRoute,
  DeveloperActivityRoute: DeveloperActivityRoute,
  DeveloperSpendingRoute: DeveloperSpendingRoute,
  DevelopersIdRoute: DevelopersIdRoute,
  DevelopersSpendingRoute: DevelopersSpendingRoute,
  DiagramsIdRoute: DiagramsIdRoute,
  ProjectsIdRoute: ProjectsIdRoute,
  QualityIdRoute: QualityIdRoute,
  ReportsRunIdRoute: ReportsRunIdRoute,
  ScheduledIdRoute: ScheduledIdRoute,
  SecretaryAccessRoute: SecretaryAccessRoute,
  ShareShareIdRoute: ShareShareIdRoute,
  SharedShareIdRoute: SharedShareIdRoute,
  DashboardsIndexRoute: DashboardsIndexRoute,
  DecksIndexRoute: DecksIndexRoute,
  DevelopersIndexRoute: DevelopersIndexRoute,
  DiagramsIndexRoute: DiagramsIndexRoute,
  ScheduledIndexRoute: ScheduledIndexRoute,
  DashboardsSharedShareIdRoute: DashboardsSharedShareIdRoute,
  DiagramsSharedShareIdRoute: DiagramsSharedShareIdRoute,
  QualitySuitesIdRoute: QualitySuitesIdRoute,
  ScheduledSharedShareIdRoute: ScheduledSharedShareIdRoute,
  SecretaryApprovalsApprovalIdRoute: SecretaryApprovalsApprovalIdRoute,
  SecretaryConnectRequestIdRoute: SecretaryConnectRequestIdRoute,
  WorkspacesIdManageRoute: WorkspacesIdManageRoute,
  QualityFindingsIdChatRoute: QualityFindingsIdChatRoute,
  WorkspacesIdCodeQualityProjectIdRoute: WorkspacesIdCodeQualityProjectIdRoute,
  ScheduledSharedShareIdReportsRunIdRoute:
    ScheduledSharedShareIdReportsRunIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
